import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Resolves 'auto' to the actual system mode
function getSystemMode() {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export const useThemeStore = create()(
  persist(
    (set, get) => ({
      preference: 'auto', // 'auto' | 'light' | 'dark'
      effectiveMode: getSystemMode(), // 'light' | 'dark' — what MUI actually uses

      setPreference: (preference) => {
        const effectiveMode = preference === 'auto' ? getSystemMode() : preference;
        set({ preference, effectiveMode });
      },

      syncSystemMode: () => {
        if (get().preference === 'auto') {
          set({ effectiveMode: getSystemMode() });
        }
      },
    }),
    {
      name: 'ripik-theme',
      partialize: (s) => ({ preference: s.preference }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          const effectiveMode = state.preference === 'auto' ? getSystemMode() : state.preference;
          state.effectiveMode = effectiveMode;
        }
      },
    }
  )
);

// Listen for system theme changes and sync when preference is 'auto'
if (typeof window !== 'undefined') {
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    useThemeStore.getState().syncSystemMode();
  });
}
